import React, { useState , useRef} from "react";
import "./Prebuild.css";
import { FaUpload } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const componentOptions = [
  "Cabinet",
  "Motherboard",
  "CPU",
  "SMPS",
  "RAM",
  "SSD",
  "Graphics Card",
  "Operating System",
];

const Prebuild = () => {
  const [form, setForm] = useState({
    name: "",
    mainImage: null,
    images: [],
    component: "",
    description: "",
    price: "",
    stock: "",
    status: "active",
  });

  const [error, setError] = useState("");

  const updateField = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const handleSubmit = () => {
    if (
      !form.name ||
      !form.mainImage ||
      !form.component ||
      !form.description ||
      !form.price ||
      !form.stock
    ) {
      setError("⚠️ Please fill all required fields.");
      return;
    }

    setError("");
    toast.success("Prebuild PC added successfully!");
  };

const [mainImage, setMainImage] = useState(null);
const [extraImages, setExtraImages] = useState(Array(6).fill(null));

const mainInputRef = useRef();
const extraInputRefs = useRef([]);

const handleMainImage = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  setMainImage({
    file,
    preview: URL.createObjectURL(file),
  });
};

const handleExtraImage = (e, index) => {
  const file = e.target.files[0];
  if (!file) return;

  const updated = [...extraImages];
  updated[index] = {
    file,
    preview: URL.createObjectURL(file),
  };

  setExtraImages(updated);
};

  return (
    <div className="adprebuild-prebuild-container">
      <ToastContainer />

      <h2 className="adprebuild-title">Add a New Prebuild PC</h2>

      {error && <p className="adprebuild-error-msg">{error}</p>}

      {/* FORM CARD */}
      <div className="adprebuild-form-card">

        {/* NAME */}
        <div className="adprebuild-form-group">
          <label>PC Name *</label>
          <input
            type="text"
            placeholder="Enter PC name"
            value={form.name}
            onChange={(e) => updateField("name", e.target.value)}
          />
        </div>

            {/* MAIN IMAGE UPLOAD */}
        <div className="adprebuild-form-group">
        <label>Main Image</label>
        <div className="adprebuild-upload-box" onClick={() => mainInputRef.current.click()}>
            {mainImage ? (
            <div className="adprebuild-preview">
                <img src={mainImage.preview} alt="Main" />
                <p>{mainImage.file.name}</p>
            </div>
            ) : (
            <p>Click to upload</p>
            )}
            <input
            type="file"
            ref={mainInputRef}
            accept="image/*"
            onChange={handleMainImage}
            style={{ display: "none" }}
            />
        </div>
        </div>

        {/* MULTIPLE IMAGES UPLOAD */}
        <div className="adprebuild-form-group">
        <label>Additional Images</label>

        <div className="adprebuild-multi-upload">
            {extraImages.map((img, i) => (
            <div className="adprebuild-upload-box small" key={i}>
                {img ? (
                <div className="adprebuild-preview">
                    <img src={img.preview} alt={`img-${i}`} />
                    <p>{img.file.name}</p>
                </div>
                ) : (
                <p>Click to upload</p>
                )}

                <input
                type="file"
                ref={(el) => (extraInputRefs.current[i] = el)}
                accept="image/*"
                onChange={(e) => handleExtraImage(e, i)}
                style={{ display: "none" }}
                />

                {/* Invisible click overlay */}
                <div
                className="adprebuild-upload-overlay"
                onClick={() => extraInputRefs.current[i].click()}
                />
            </div>
            ))}
        </div>
        </div>

        {/* COMPONENT ROWS (two columns) */}
        <div className="adprebuild-component-grid">

            <div className="adprebuild-form-group">
                <label>Cabinet *</label>
                <select> <option>Select Cabinet</option> {componentOptions.map((c) => <option key={c}>{c}</option>)} </select>
            </div>

            <div className="adprebuild-form-group">
                <label>Motherboard *</label>
                <select> <option>Select Motherboard</option> {componentOptions.map((c) => <option key={c}>{c}</option>)} </select>
            </div>

            <div className="adprebuild-form-group">
                <label>CPU *</label>
                <select> <option>Select CPU</option> {componentOptions.map((c) => <option key={c}>{c}</option>)} </select>
            </div>

            <div className="adprebuild-form-group">
                <label>SMPS *</label>
                <select> <option>Select SMPS</option> {componentOptions.map((c) => <option key={c}>{c}</option>)} </select>
            </div>

            <div className="adprebuild-form-group">
                <label>RAM *</label>
                <select> <option>Select RAM</option> {componentOptions.map((c) => <option key={c}>{c}</option>)} </select>
            </div>

            <div className="adprebuild-form-group">
                <label>SSD *</label>
                <select> <option>Select SSD</option> {componentOptions.map((c) => <option key={c}>{c}</option>)} </select>
            </div>

            <div className="adprebuild-form-group">
                <label>GPU *</label>
                <select> <option>Select GPU</option> {componentOptions.map((c) => <option key={c}>{c}</option>)} </select>
            </div>

            <div className="adprebuild-form-group">
                <label>Operating System *</label>
                <select> <option>Select Operating System</option> {componentOptions.map((c) => <option key={c}>{c}</option>)} </select>
            </div>

            <div className="adprebuild-form-group">
                <label>Price *</label>
                <input type="number" placeholder="Enter price" value={form.price} onChange={(e) => updateField("price", e.target.value)} />
            </div>

            <div className="adprebuild-form-group">
                <label>Stock in Hand *</label>
                <input type="number" placeholder="Enter stock" value={form.stock} onChange={(e) => updateField("stock", e.target.value)} />
            </div>

            <div className="adprebuild-form-group">
                <label>Status *</label>
                <select value={form.status} onChange={(e) => updateField("status", e.target.value)} > <option value="active">Active</option> <option value="inactive">Inactive</option> </select>
            </div>

        </div>

        {/* DESCRIPTION */}
        <div className="adprebuild-form-group">
          <label>Description *</label>
          <textarea
            placeholder="Write description..."
            value={form.description}
            onChange={(e) => updateField("description", e.target.value)}
          />
        </div>

        {/* BUTTONS */}
        <div className="adprebuild-btn-row">
          <button className="adprebuild-cancel-btn">Cancel</button>
          <button className="adprebuild-submit-btn" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default Prebuild;
